import { useState, useEffect } from "react";
import { useLocation , useNavigate } from "react-router-dom";
import { getDatabase, ref, get, update  } from "firebase/database";

import Alertadenegado from "../alertadenegado"; 

import ProteccionAdmin from "./proteccionadmin";

export default function VistaItem() {
  const location = useLocation();
  const navigate = useNavigate();
  const { categoria, producto, mesa } = location.state || {}; // Obtenemos datos enviados por navigate

  const [datosProducto, setDatosProducto] = useState(null);
  const [cantidad, setCantidad] = useState(1);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito
  const [denegado, setDenegado] = useState(false);

// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};

     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);

  useEffect(() => {
    if (categoria && producto) {
      const db = getDatabase();
      const productoRef = ref(db, `nature/Awoo/Categorias/${categoria}/${producto}`);

      get(productoRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            if (!data.visibilidad) {
              data.visibilidad = "Si"; // Valor por defecto si no existe
            }
            setDatosProducto(snapshot.val()); // Guardamos los datos en el estado
          } else {
            console.error("Producto no encontrado");
          }
        })
        .catch((error) => {
          console.error("Error al obtener el producto:", error);
        });
    }
  }, [categoria, producto]);

  ////////////////// 🚫 Si el acceso está denegado, solo muestra el AlertDialog
  if (denegado) {
    return (
      <Alertadenegado
        open={true}
        onClose={() => {
          setDenegado(false);
          navigate(-1); // Regresa a la página anterior o redirige donde necesites
        }}
      />
    );
  }
  ///////////////////////////
   

  if (!categoria || !producto) {
    return <div>Error: No se encontraron datos del producto.</div>;
  }

  if (!datosProducto) {
    return <div>Cargando...</div>;
  }

  const precioTotal = cantidad * datosProducto.Precio;



  // 🔹 Función para guardar en localStorage
  const guardarCarrito = (nuevoCarrito) => {
    localStorage.setItem("carrito", JSON.stringify(nuevoCarrito));
  };

  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };


// 🔹 Función para agregar al carrito
const agregarAlCarrito = () => {
    let carrito = obtenerCarrito();
  
    // Buscar el producto en el carrito
    const index = carrito.findIndex(
      (item) => item.categoria === categoria && item.producto === producto
    );
  
    if (index !== -1) {
      // Si el producto ya está en el carrito
      if (carrito[index].cantidad !== cantidad) {
        // Si la cantidad es diferente, actualizamos el valor en el carrito
        carrito[index].cantidad = cantidad;
        guardarCarrito(carrito);
        alert(`✅ Se actualizó la cantidad de ${producto} a ${cantidad}.`);
      } else {
        // Si la cantidad es la misma, no hacemos nada
        alert("⚠️ Este producto ya está en el carrito con la misma cantidad.");
      }
    } else {
      // Si el producto no está en el carrito, lo agregamos normalmente
      const productoAAgregar = {
        categoria, 
        producto,
        cantidad,
        Img: datosProducto.Img,
        Titulo: datosProducto.Titulo,
        Descripcion: datosProducto.Descripción,
        Calificacion: datosProducto.Calificacion || "",
        Precio: datosProducto.Precio,
        Costo:datosProducto.Costo
      };
  
      carrito.push(productoAAgregar);
      guardarCarrito(carrito);
  
      alert(`✅ Producto añadido al carrito:\n📌 Categoría: ${categoria}\n📦 Producto: ${producto}\n📊 Cantidad: ${cantidad}`);
    }
};
// Función para comprar ahora
const comprarAhora = () => {
  let carrito = obtenerCarrito();

  // Buscar el producto en el carrito
  const index = carrito.findIndex(
    (item) => item.categoria === categoria && item.producto === producto
  );

  // 🔹 Lógica para obtener la imagen
  let imagenUrl = datosProducto.Img;

  if (!imagenUrl && datosProducto.Visuales) {
    const visualesArray = Object.values(datosProducto.Visuales)
      .filter((item) => item && item.tipo === "imagen")
      .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

    if (visualesArray.length > 0) {
      imagenUrl = visualesArray[0].url;
    }
  }

  imagenUrl = imagenUrl || "images/default.jpg"; // Imagen por defecto

  if (index !== -1) {
    if (carrito[index].cantidad !== cantidad) {
      carrito[index].cantidad = cantidad;
      guardarCarrito(carrito);
      alert(`✅ Se actualizó la cantidad de ${producto} a ${cantidad}.`);
    }
  } else {
    const productoAAgregar = {
      categoria,
      producto,
      cantidad,
      Img: imagenUrl, // 🔹 Imagen correcta
      Titulo: datosProducto.Titulo,
      Descripcion: datosProducto.Descripción,
      Calificacion: datosProducto.Calificacion || "4.9",
      Precio: datosProducto.Precio,
      Costo: datosProducto.Costo
    };

    carrito.push(productoAAgregar);
    guardarCarrito(carrito);

    alert(`✅ Producto añadido al carrito:\n📌 Categoría: ${categoria}\n📦 Producto: ${producto}\n📊 Cantidad: ${cantidad}`);
  }

  // Redirigir a la página de resumen
  navigate("/3dfyrionresumen", { state: { mesa } });
};









  return (


    
    <ProteccionAdmin>

<div style={styles.container}>

{/* Boton Carrito de Compras */}
<div
style={{
display: "flex",
justifyContent: "flex-end", // Alineado a la derecha
alignItems: "center",
marginLeft: "15px",
position: "relative",
marginRight: "65px", // Espacio a la derecha
marginTop:"10px",
width:"100%",
justifyContent: "right",
flexShrink: 0, // Evita que las tarjetas se reduzcan
}}
>

{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
<div
onClick={irAlCarrito}
style={{
  marginLeft: "15px",
  position: "relative",
  width: "60px",
  flexShrink: 0, // Evita que las tarjetas se reduzcan
  visibility: carritoCantidad > 0 ? "visible" : "hidden", // Oculta pero mantiene el espacio
}}
>
<div
  style={{
    position: "relative",
    borderRadius: "15px",
    overflow: "visible",
  }}
>
  {/* Círculo del carrito */}
  <div
    style={{
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      border: "5px solid #2ae5e2",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundImage: "url('images/carrito.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  ></div>

  {/* Etiqueta inferior con cantidad */}
  <div
    style={{
      position: "absolute",
      bottom: "-10px",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "#fa0a02",
      color: "white",
      padding: "4px 8px",
      borderRadius: "10px",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "12px",
    }}
  >
    {carritoCantidad}
  </div>
</div>
</div>

</div>


  <div style={styles.imageContainer}>
    <img src={datosProducto.Img} alt={datosProducto.Titulo} style={styles.image} />
  </div>


  <div style={styles.card}
  >
    <h2 style={styles.title}>{datosProducto.Titulo}</h2>
    <p style={styles.description}>{datosProducto.Descripción}</p>
  </div>

  <div style={styles.footerBar}>
    <div style={styles.row}>
      <div style={styles.quantityControls}>
        <button onClick={() => setCantidad(Math.max(1, cantidad - 1))} style={styles.botonCantidad}>-</button>
        <span style={styles.quantityText}>{cantidad}</span>
        <button onClick={() => setCantidad(cantidad + 1)} style={styles.botonCantidad}>+</button>
      </div>
      <div style={styles.price}>${precioTotal.toLocaleString()}</div>
    </div>

    <div style={styles.buttonRow}>
      <button onClick={agregarAlCarrito} style={styles.botonSecundario}>Añadir al Carrito</button>
      <button onClick={comprarAhora} style={styles.botonPrincipal}>Comprar Ahora</button>
    </div>
  </div>
</div>

    </ProteccionAdmin>


  );
}

// 📌 Estilos
const styles = {
  container: { display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#000", color: "#fff", alignItems: "center", paddingBottom: "80px" },
  imageContainer: { width: "100%", height: "40vh", overflow: "hidden", borderRadius: "0 0 20px 20px", marginTop:"-80px" },
  image: { width: "100%", height: "100%", objectFit: "cover" },
  card: { width: "90%", backgroundColor: "#fff", borderRadius: "20px", padding: "20px", marginTop: "-20px", boxShadow: "0px 4px 10px rgba(255, 255, 255, 0.2)", textAlign: "center", color: "#000" },
  title: { marginBottom: "10px", fontSize: "17px", fontWeight: "bold", color: "#000000" },
  description: { fontSize: "13px", color: "#838181" },
  footerBar: { position: "fixed", bottom: 0, width: "90%", backgroundColor: "#222", padding: "15px", borderRadius: "20px 20px 0 0", boxShadow: "0 -4px 15px rgb(25, 247, 255)", display: "flex", flexDirection: "column", alignItems: "center" },
  row: { display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginBottom: "10px" },
  quantityControls: { display: "flex", alignItems: "center" },
  botonCantidad: { width: "35px", height: "35px", backgroundColor: "#444", color: "#faa302", fontSize: "25px", border: "none", borderRadius: "8px", cursor: "pointer" },
  quantityText: { margin: "0 10px", fontSize: "18px", fontWeight: "bold" },
  price: { fontSize: "20px", fontWeight: "bold", color: "#e27f0e" },
  buttonRow: { display: "flex", gap: "10px", width: "100%" },
  botonPrincipal: { flex: 1, backgroundColor: "#33c61e", color: "#fff", fontSize: "16px", padding: "10px", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: "bold" },
  botonSecundario: { flex: 1, backgroundColor: "#e72dd8", color: "#fff", fontSize: "16px", padding: "10px", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: "bold" },
};